// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3EBV6","lastUpdated":"style_lastUpdated__1Tlw6","indentedBullet":"style_indentedBullet__3Lxyw"};